import { Button, Grid, IconButton } from '@material-ui/core';
import { Visibility as VisibilityIcon } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import theme from './theme';
import { getFileURLPDF } from '@webapps/utils';
import {getUserInvoices} from "@webapps/business";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useQuery,
} from '@webapps/reactjs-tech-components';
import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';


const { NX_REST_API, NX_PROXY_API } = process.env;

const {
  colors: { addressColor, background },
} = theme;

const Invoices = ({ accountInfos = [], refetchAccountInfo }) => {
  const { classes, css, global, cx, theme: { spacing } } = useStyles(styles);
  
  const { data: invoices } = useQuery(getUserInvoices, {
    key: 'userInvoices',
    variables: { id: accountInfos.sub_id },
  });
  
  // State that define subscritpion end date (by default, 1 month after today)
  const dayOfNow = Date.now();
  let initialEndDate = new Date(dayOfNow);
  initialEndDate.setMonth(initialEndDate.getMonth() + 1);

  // Format date
  function dateFormat(string) {
    return string.split("-").reverse().join("-");
  }

  // If user clicks to see invoices, display invoices
  function getInvoices() {
    if (invoices.length > 0 ) {
      return invoices.map(invoice => 
        <div key={invoice.id} style={{display: 'block'}}>
          <p>{dateFormat(invoice.date)} : &nbsp; <a target='blank' href={invoice.public_url}>Télécharger</a></p>
        </div>
      )
    } else {
      return (
        <div style={{display: 'block'}}>
          <p>Aucune facture n'est disponible pour le moment</p>
        </div>
      )
    }
  }
  const [viewInvoice, setViewInvoice] = useState(false);
  const [path, setPath] = useState('');

  const goToPath = (url) => {
    // eslint-disable-next-line no-unused-expressions
    url.includes('http')
      ? window.open(url, '_blank', 'noopener,noreferrer')
      : window.open(`http://${url}`, '_blank', 'noopener,noreferrer');
  };

  const handleOpenViewInvoice = (link, type) => {
    setPath('');
    getFileURLPDF(link, setPath);
    if (type === 'link' || type === 'lien') goToPath(link);
    else setViewInvoice(true);
  };
  const handleCloseViewInvoice = () => {
    setViewInvoice(false);
  };

  return (
    <div>
      {!invoices?.invoices?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer className={css({ marginBottom: spacing(3) })}>
          <Table>
            <TableHead>
              <TableHeadRow>
                <TableHeadCell className={global.infoText}>
                  <FormattedMessage id="student.profil.realisation.table.nom" />
                </TableHeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {invoices?.invoices?.map(({ id, label, public_url }) => (
                <TableRow key={id}>
                  <TableCell className={global.infoText}>{label}</TableCell>
                  <TableCell>
                    <IconButton size="small">
                      <VisibilityIcon
                        color="primary"
                        fontSize="small"
                        onClick={() =>
                          handleOpenViewInvoice(public_url, 'lien')
                        }
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ModalFullScreenWithoutAction
        onCancel={handleCloseViewInvoice}
        open={viewInvoice}
        title="Facture"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(2.5),
  },
  gridContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    display: 'flex',
    gap: spacing(2),
    alignItems: 'center',
  },
  itemPref: {
    display: 'flex',
    alignItems: 'center',
    color: addressColor,
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    
    
    
    
  },
  btnUnsubscribe : {
    lineHeight: "1.2",
    marginLeft: '15px',
    marginBottom: '20px',
    width: '33%',
    maxWidth: '350px',
    backgroundColor: 'crimson',
  },
  btnLogout: {
    marginTop: spacing(2.5),
    backgroundColor: 'white'
  },
  btnChangePayment : {
    lineHeight: "1.2",
    width: '33%',
  },
  btnSetPayment : {
    lineHeight: "1.2",
    marginLeft: '15px',
    marginBottom: '20px',
    width: '45%',
    maxWidth: '350px',
  },
  btnCancel : {
    lineHeight: "1.2",
    width: '45%',
    backgroundColor: 'crimson',
  },
  StripeContainer : {
    width: '25%',
    marginLeft: '15px',
    marginBottom: '20px'
  },
});

Invoices.propTypes = {
  accountInfos: PropTypes.object,
  refetchAccountInfo: PropTypes.func,
};

export default Invoices;
